import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
//import { ElementTypeEnum, FormatType, NgWhiteboardService, ToolsEnum, WhiteboardElement, formatTypes } from 'ng-whiteboard';
//import { initializeApp } from 'firebase/app';
//import { getAnalytics } from 'firebase/analytics';
//import { getDatabase, ref, set, onValue } from 'firebase/database';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-lab-map',
  templateUrl: './lab-map.component.html',
  //providers: [ NgWhiteboardService ],
  encapsulation: ViewEncapsulation.ShadowDom,
  styleUrls: ['./lab-map.component.css']
})
export class LabMapComponent {
  /*toolsEnum = ToolsEnum;
  elementTypeEnum = ElementTypeEnum;
  selectedTool: ToolsEnum = ToolsEnum.BRUSH;
  whiteboardData:WhiteboardElement[];
  color = '#333333';
  backgroundColor = '#eee';
  size = 5;
  isSizeActive = false;
  isSaveActive = false;
  formatType = FormatType;
  machineNavigate = false;

  constructor(private whiteboardService: NgWhiteboardService, private router:Router) {
    var storedWhiteboard = JSON.parse(localStorage.getItem("whiteboard"))
    if (storedWhiteboard)
      this.whiteboardData = storedWhiteboard
  }

  onSave(img: string) {
    // Copy to clipboard
    const cb = navigator.clipboard;
    if (cb) {
      cb.writeText(img);
    }
  }

  erase() {
    this.whiteboardService.erase();
  }
  setSize(size: number) {
    this.size = size;
    this.isSizeActive = false;
  }
  save(type: formatTypes) {
    this.whiteboardService.save(type);
    this.isSaveActive = false;
  }
  undo() {
    this.whiteboardService.undo();
  }
  redo() {
    this.whiteboardService.redo();
  }

  addImage(fileInput: EventTarget | null) {
    if (fileInput) {
      const files = (fileInput as HTMLInputElement).files;
      if (files) {
        const reader = new FileReader();
        reader.onload = (e: ProgressEvent) => {
          const image = (e.target as FileReader).result;
          this.whiteboardService.addImage(image as string);
        };
        reader.readAsDataURL(files[0]);
      }
    }
  }

  setColor(event: Event) {
    const target = event.target as HTMLInputElement;
    this.color = target.value;
  }

  setBackgroundColor(event: Event) {
    const target = event.target as HTMLInputElement;
    this.backgroundColor = target.value;
  }

  SelectElement (element:WhiteboardElement) {
    console.log(element);
    console.log(this.whiteboardData);
    if (this.machineNavigate && element && element.type == this.elementTypeEnum.TEXT){
      this.router.navigate(['machine-detail/', element.value])
    }
  }

  UpdateWhiteboard(elements:WhiteboardElement[]){
    localStorage.setItem('whiteboard', JSON.stringify(elements));
  }*/
}
